import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NotificationService } from 'app/_services/notification.service';
import { SiteService } from 'app/_services/site.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
  selector: 'app-site-location',
  templateUrl: './site-location.component.html'
})
export class SiteLocationComponent implements OnInit {

  public selectedSite: any;
  private selectedSiteId: any;
  public tooltipMessage: string = 'Workers on this site will not have their location recorded outside of this area';

  // Map Variables
  public zoom = 12;
  public lat = 51.673858;
  public lng = 7.815982;
  public geofence = 1000;
  @ViewChild('placesRef', { static: true }) placesRef: GooglePlaceDirective; // View Child for Google places search input
  markers: Marker[] = [];

  constructor(
    private siteService: SiteService,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationService
  ) {
    // Get Site id from params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });
  }

  ngOnInit() {
    this.getSelectedSite(this.selectedSiteId);
  }

  // Get Selected Site
  public getSelectedSite(id) {
    this.siteService.getSiteById(id)
      .subscribe((data: any) => {
        this.selectedSite = data;
        this.lat = data.latitude;
        this.lng = data.longitude;
        this.geofence = data.geofence;
      })
  }

  // Handle Address Change
  public handleAddressChange(address: Address) {
    this.lat = address.geometry.location.lat();
    this.lng = address.geometry.location.lng();
  }

  public latLngChange() {
    this.resetLocationField();
  }

  // Handle Marker Drag Event
  public markerDragEnd(event) {
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;

    this.resetLocationField();
  }

  private resetLocationField() {
    const locationField = (this.placesRef as any);
    if (locationField && locationField.el && locationField.el.nativeElement) {
      locationField.el.nativeElement.value = '';
    }
  }

  public radiusChanged(event) {
    this.geofence = Math.round(event);
  }

  // Update Site Location
  public saveLocation() {
    const newDetails = {
      latitude: this.lat,
      longitude: this.lng,
      geofence: this.geofence,
    };

    const body = this.siteService.createRequestBodyForEditingSite(this.selectedSite, newDetails);

    this.siteService.editSiteDetails(body)
      .subscribe((data: any) => {
        this.getSelectedSite(this.selectedSiteId);
        this.notificationService.notify('success', 'Location Updated', 'Site location has successfully been updated.');
      })
  }
}

interface Marker {
  lat: number;
  lng: number;
  draggable?: boolean;
}
